// Social network type identifiers from PSA_MEN_SOC_NET
export const SocialNetworkIdentifiers = {
  FACEBOOK: 'PSA_MEN_SOC_NET_FBK',
  LINKEDIN: 'PSA_MEN_SOC_NET_LNK',
  XING: 'PSA_MEN_SOC_NET_XNG',
  TWITTER: 'PSA_MEN_SOC_NET_TWI',
  YOUTUBE: 'PSA_MEN_SOC_NET_YTU',
} as const

export type SocialNetworkType = string
